module.exports = __webpack_public_path__ + "img/TOPbanner.aa23d4cd.png";